import { atom } from "jotai";

// this is used to track the status of the authentication process
export const $authStatus = atom(
	"initializing" as
		| "initializing"
		| "logging-in"
		| "external-browser-login"
		| "logging-out"
		| "logged-in"
		| "logged-out"
		| "logged-out-forced"
		| "error"
);
$authStatus.debugLabel = "authentication.authStatusAtom";
